import {createAction, props} from '@ngrx/store';
import {ApolloError} from 'apollo-client';
import {Payload} from '../payload';

export const reportError = createAction('[ERRORS] Report error', props<Payload<ApolloError>>());
export const setErrorMessages = createAction('[ERRORS] Set errormessages', props<Payload<Set<string>>>());
